import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import {
  faClipboard,
  faDownload,
  faHome,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getAllIntstallationByDate,
  getInstallationDetails,
  getInstallationExcelDownload,
  getInstallationPdfDownload,
  getServiceInstallationExcel,
  getServiceInstallationPdf,
  getservicesinstallationDispenserSerialNumber,
} from "../../Service/AllServicesAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";
import { toBeRequired } from "@testing-library/jest-dom/dist/to-be-required";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  const [entries, setEntries] = useState([]);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // --- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);

  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getInstallationDetails(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Production Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setTotalCount();
            swal("Sorry", "Installation Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
      console.log("entries", entries);
    }
    // Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      setisLoaded(true);
      await getAllIntstallationByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Field Issue Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setTotalCount();
            swal("Sorry", " Installation Data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  useEffect(() => {
    getAllInstallation(); // Function call to get installation list
  }, []);

  const getAllInstallation = async () => {
    try {
      setTimeout(async () => {
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        setisLoaded(true);
        await getInstallationDetails(currentPage, fkUserId, role, headers)
          .then((result) => {
            setisLoaded(false);
            console.log("Get Installation Result", result.data);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
              setisLoaded(false);
            }
            // console.log("setNoOfElements", noOfElements);
          })
          .catch((error) => {
            console.log("Get Installation Error (Service installation data is not present.)", error);
            // swal(
            //   "Sorry",
            //   "Service installation data is not present.",
            //   "warning"
            // );
          });
      }, 100);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // const getAllInstallationFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // Function declaration for setting toDate on "todate" Product change event
  // const getAllInstallationToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getInstallationByDate = async () => {
    try {
      setTimeout(async () => {
        // setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {
          await getAllIntstallationByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              setisLoaded(false);
              console.log("Get Date wise installation Result", result.data);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
                // setToDate("")
                // setFromDate("")
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                setisLoaded(false);
                swal(
                  "Sorry",
                  "Service installation data is not present for selected date.",
                  "warning"
                );
              }
            })
            .catch((error) => {
              console.log("Get installation Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getInstallationReportPdfDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        setisLoaded(true);
        await getInstallationPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "404 error ",
          "error"
        );
      }
    } else {
      try {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        let result = await getServiceInstallationPdf(
          token,
          fileType,
          role,
          fkUserId
        );
        console.log("getServiceInstallation Pdf result :-", result);
        setisLoaded(false);
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log("getServiceInstallationPdf error :-", error);
      }
    }
  };

  const getInstallationReportExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getInstallationExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log("getFieldIssueWorkOrderExcelDownload error :-", error);
      }
    } else {
      try {
        await getServiceInstallationExcel();
        console.log("getServiceInstallation Excel result :-");
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log("getServiceInstallationExcel error :-", error);
      }
    }
  };

  const sendImage = (cell) => {
    console.log("cell", cell);
    const newCell = cell.uploadDispenserPhoto?.split(",");
    console.log("newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src="data:image/${newCell[0]};base64,${newCell[1]}" />`
    );
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);

    getAllInstallation();
  };


  const search = async (e) => {
    console.log("e :-", e);
    setSearchPerformed(true);
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return; // Exit early if the search input is empty
    }

    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const result = await getservicesinstallationDispenserSerialNumber(currentPage, searchDispenserSerialNumber, role, fkUserId, headers);
      console.log("cheking data for services installation ", result?.content)
      console.log("Searching for Dispenser Serial Number:", searchDispenserSerialNumber);

      if (result?.content?.length > 0) {
        const sortedData = result.content.sort((a, b) => b.pkUserId - a.pkUserId);
        setEntries(sortedData);
        setPageCount(1);
        setTotalCount(sortedData.length);


      } else {
        swal("No Data", "No records found for the given serial number", "info");

        setEntries([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };
  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Product list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "installationStatus",
      text: "Installation Wo Status",
      editable: false,
      headerAlign: "left",

    },

    {
      dataField: "workOrderNo",
      text: "Installation Wo Sr No",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "installationDate",
      text: "Installation Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "installationTime",
      text: "Installation Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },

    // {
    //   dataField: "siteAddress",
    //   text: "Site Address",
    //   editable: false,
    //   style: { textTransform: "capitalize"},
    //   formatter: (cell, row) => (
    //     <div className="tooltip-container">
    //       <div className="truncated-text">{cell}</div>
    //       {cell.length > 20 && (
    //         <span className="tooltip-text">{row.siteAddress}</span>
    //       )}
    //     </div>
    //   )
    // },

    {
      dataField: "siteAddress",
      text: "Site Address",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell || "N/A"}</div>
          {(cell && cell.length > 20) && (
            <span className="tooltip-text">{row.siteAddress}</span>
          )}
        </div>
      )
    }
    ,

    // {
    //   dataField: "modelName",
    //   text: "Dispenser Config",
    //   editable: false,
    //   headerAlign: "left",
    //   style: {
    //     textTransform: "capitalize",
    //     textAlign:'center'
    //   },
    // },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   editable: false,
    //   headerAlign: "left",
    //   width: 100,
    // },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
      width: 100,
    },

    {
      dataField: "uploadDispenserPhoto",
      text: "Dispenser Photo",
      editable: false,
      headerAlign: "left",
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendImage(cell)}
              disabled={!cell.uploadDispenserPhoto ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>

      <Formik
        initialValues={{
          firstname: "",
          lastname: "",
          companyname: "",
          mobileno: "",
          selectdesignation: "",
          email: "",
          country: "",
          state: "",
          address: "",
          city: "",
          desc: "",
        }}
        onSubmit={async (values) => {
          console.log(JSON.stringify(values, null, 2));
        }}
      >
        {(formik) => {
          return (
            <>

              <>
                <Row>
                  <Col
                    md={{ span: 3, order: 1 }}
                    className="mb-3"
                    xs={{ order: 2 }}
                  >
                    <div className="form-group">
                      <label>From Date</label>
                      <DatePicker
                        selected={fromDate}
                        onChange={handleFromDateChange}
                        dateFormat="dd-MMM-yyyy"
                        maxDate={new Date()}
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                      />
                    </div>
                  </Col>
                  <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                    <div className="form-group">
                      <label>To Date</label>
                      <DatePicker
                        selected={toDate}
                        onChange={handleToDateChange}
                        dateFormat="dd-MMM-yyyy"
                        minDate={fromDate}
                        maxDate={new Date()}
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                      />
                    </div>
                  </Col>
                  <Col
                    md={{ span: 3, order: 2 }}
                    className="mb-3"
                    xs={{ order: 4 }}
                  >
                    <button
                      className="btn btn-secondary mt-lg-4"
                      onClick={getInstallationByDate}
                    >
                      <FontAwesomeIcon icon={faSearch} className="me-2" />
                      <span>Search By Date</span>{" "}
                    </button>
                  </Col>
                  {role === "service engineer" ? (
                    <>
                      <Col
                        md={{ span: 3, order: 4 }}
                        className="mt-4"
                        xs={{ order: 1 }}
                      >
                        <div className="newadd" align="right">
                          <Link
                            to="verification-installation-list"
                            className="btn btn-secondary"
                          >
                            <FontAwesomeIcon
                              icon={faPlus}
                              className="me-2"
                            />
                            <span>My Jobs </span>{" "}
                          </Link>
                          {/* } */}
                        </div>
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}
                </Row>
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange: (page) => {
                          handlePageChange(page);
                        },
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1 md-3 d-flex ">

                                  <input
                                    type="search"
                                    placeholder="Search by dispenser Sr No..."
                                    value={searchDispenserSerialNumber}
                                    onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                                    className="form-control-alternative form-control searchinput "
                                    style={{ marginRight: '10px' }}
                                  />

                                  <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : search}>
                                    <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                                    <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                                  </button>

                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  <button
                                    className="btn btn-secondary"
                                    onClick={
                                      getInstallationReportPdfDownload
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      className="me-2"
                                    />
                                    <span>PDF</span>
                                  </button>
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={
                                      getInstallationReportExcelDownload
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      className="me-2"
                                    />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            {isLoaded ? (
                              <div className="text-center bg-black text-white"> Please wait installation data is loading ... </div>
                            ) : (
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                filter={filterFactory()}
                                remote={{ pagination: true }}
                                headerClasses="header-class"
                                hover
                                striped
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    console.log(
                                      oldValue,
                                      newValue,
                                      row,
                                      column
                                    );
                                  },
                                })}
                                // selectRow={selectRow}
                                wrapperClasses="table-responsive"
                              />
                            )}
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                ></Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>

            </>
          );
        }}
      </Formik>

    </>
  );
};
